<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" allow-all @change="refresh()" option="All" hide-details/>
        </v-col>
        <v-col cols="2">
          <v-autocomplete label="Period" dense outlined hide-details :items="['daily','weekly','monthly','quarterly','yearly']" v-model="period" @change="refresh()"/>
        </v-col>
        <v-col cols="2">
          <v-switch label="By spirit" dense v-model="bySpirit" hide-details  class="mt-1 ml-1" @change="refresh()"/>
        </v-col>

        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Casks fill', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsCasksFill',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      period: 'yearly',
      bySpirit: true,
      loading: true,
      lines: []
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  async created() {
    this.$emit('name', 'Cask fill report')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsCasksFill($from:Date,$to:Date,$period:String!, $bySpirit:Boolean!) {
                                             casksFillReport(from:$from,to:$to,period:$period,bySpirit:$bySpirit) {
                                              period,spirit,casks,laa
                                             }
                                           }`,
                                          {from:this.from,to:this.to,period:this.period,bySpirit:this.bySpirit});
      if (!results.error) {
        this.initialBalance = results.data.spiritsBalanceTo;
        this.lines = results.data.casksFillReport;
      }
      this.loading = false;

    },

    report() {
      const lines = [
                  `<style>
                    @page {size:landscape}
                    .report {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
                    .report th {height:36px;padding:0 16px;vertical-align:middle}
                    .report .spacer {height:18px}
                    .report td {height:36px;padding:0 16px;vertical-align:middle}
                    .report .title {font-size:18px;text-transform:uppercase}
                    .report .sup-title {font-weight:normal;font-size:22px}
                    .report .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                    .report .header th {border-bottom:1px solid #000;margin-bottom:20px}
                    .report .text-left {text-align:left}
                    .report .text-right {text-align:right}
                    .report .font-weight-bold {font-weight:bold}
                    .report .total-row {font-weight:bold}
                  </style>
                   <table class="report">
                     <thead>
                        <tr>
                          <th colspan="4" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="4" class="title">Casks Fill Report</th>
                        </tr>
                        <tr>
                           <th colspan="4" class="sub-title">${this.dateDisplay}</th>
                        </tr>

                        <tr class="header">
                          <th width="15%" class="text-left">${{'daily':'Day','weekly':'Week','monthly':'Month','quarterly':'Quarter','yearly':'Year'}[this.period]}</th>
                          ${this.bySpirit?`<th width="35%" class="text-left">Spirit</th>`:``}
                          <th width="25%" class="text-right">Casks</th>
                          <th width="25%" class="text-right">LAA</th>
                        </tr>
                      </thead>
                      <tbody>`
    ];
    let period;
    let casks = 0;
    let laa = 0;
    let totalCasks = 0;
    let totalLAA = 0;
    for (const line of this.lines) {
      if (period && period !== line.period && this.bySpirit) {
        lines.push(`<tr>`);
        lines.push(`<td colspan="2" class="text-right font-weight-bold">Total</td>`);
        lines.push(`<td class="text-right font-weight-bold">${this.$number(casks,0)}</td>`);
        lines.push(`<td class="text-right font-weight-bold">${this.$number(laa,3)}</td>`);
        lines.push(`</tr>`);
        casks = 0;
        laa = 0;
      }
      lines.push(`<tr>`);
      lines.push(`<td>${period === line.period ? '' : line.period}</td>`);
      casks += line.casks;
      laa += line.laa;
      totalCasks += line.casks;
      totalLAA += line.laa;
      if (this.bySpirit)
        lines.push(`<td>${line.spirit}</td>`);
      lines.push(`<td class="text-right">${this.$number(line.casks,0)}</td>`);
      lines.push(`<td class="text-right">${this.$number(line.laa,3)}</td>`);
      lines.push(`</tr>`);
      period = line.period;

//      lines.push(`<tr><td colspan="4" class="spacer"/></tr>`);
    }
    if (this.lines.length && this.bySpirit) {
      lines.push(`<tr>`);
      lines.push(`<td colspan="2" class="text-right font-weight-bold">Total</td>`);
      lines.push(`<td class="text-right font-weight-bold">${this.$number(casks,0)}</td>`);
      lines.push(`<td class="text-right font-weight-bold">${this.$number(laa,3)}</td>`);
      lines.push(`</tr>`);
    }

    lines.push(`<tr>`);
    lines.push(`<td colspan="${this.bySpirit?2:1}" class="text-right font-weight-bold">Grand total</td>`);
    lines.push(`<td class="text-right font-weight-bold">${this.$number(totalCasks,0)}</td>`);
    lines.push(`<td class="text-right font-weight-bold">${this.$number(totalLAA,3)}</td>`);
    lines.push(`</tr>`);

    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,`,
                      `"Casks Fill Report",,`,
                      `"${this.dateDisplay}",,`,
                      `"${{'daily':'Day','weekly':'Week','monthly':'Month','quarterly':'Quarter','yearly':'Year'}[this.period]}",${this.bySpirit?`"Spirit",`:''}"Casks","LAA"`
                    ];
      for (const line of this.lines)
        lines.push(`"${line.period}",${this.bySpirit?`"${line.spirit}",`:``}"${this.$number(line.casks,0)}","${this.$number(line.laa,3)}"`);

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Casks fill report.csv');
    }
  }
}
</script>